import { useRef } from 'react';
// components
import { CheckPicker } from 'rsuite';
import { ExButton } from '@commons/EXComponentsLibrary';
// styles
import styles from './ExMultiSelectionWithApply.module.css';

const ExMultiSelectionWithApply = ({
    key,
    data,
    handleApply,
    isLoading,
    handleSetter,
    handleClean,
    searchPlaceholder,
    height,
    width,
    menuMaxHeight,
    valueKey,
    labelKey,
}) => {
    const selectRef: any = useRef(null);
    const pickerRef: any = useRef(null);

    return (
        <>
            <CheckPicker
                key={key}
                ref={pickerRef}
                container={
                    typeof window !== 'undefined' && selectRef?.current
                        ? selectRef.current || document?.body
                        : undefined
                }
                data={data}
                style={{ height, width }}
                sort={() => (a, b) => a?.[labelKey]?.localeCompare(b?.[labelKey])}
                valueKey={valueKey}
                labelKey={labelKey}
                menuMaxHeight={menuMaxHeight}
                className={styles['select']}
                renderExtraFooter={() => (
                    <div style={{ padding: 16 }}>
                        <ExButton fullWidth onClick={() => handleApply() && pickerRef.current?.close?.()}>
                            Aplicar
                        </ExButton>
                    </div>
                )}
                placeholder="Filtrar por cliente"
                disabled={isLoading}
                renderValue={(value, items) => (
                    <span className={styles['render-value-select']}>
                        <span className={styles['icon']}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M5.02545 21C4.47545 21 4.00462 20.8042 3.61295 20.4125C3.22129 20.0208 3.02545 19.55 3.02545 19V11.05C2.64212 10.7 2.34629 10.25 2.13795 9.7C1.92962 9.15 1.92545 8.55 2.12545 7.9L3.17545 4.5C3.30879 4.06667 3.54629 3.70833 3.88795 3.425C4.22962 3.14167 4.62545 3 5.07545 3H18.9755C19.4255 3 19.8171 3.1375 20.1505 3.4125C20.4838 3.6875 20.7255 4.05 20.8755 4.5L21.9255 7.9C22.1255 8.55 22.1213 9.14167 21.913 9.675C21.7046 10.2083 21.4088 10.6667 21.0255 11.05V19C21.0255 19.55 20.8296 20.0208 20.438 20.4125C20.0463 20.8042 19.5755 21 19.0255 21H5.02545ZM14.2255 10C14.6755 10 15.0171 9.84583 15.2505 9.5375C15.4838 9.22917 15.5755 8.88333 15.5255 8.5L14.9755 5H13.0255V8.7C13.0255 9.05 13.1421 9.35417 13.3755 9.6125C13.6088 9.87083 13.8921 10 14.2255 10ZM9.72545 10C10.1088 10 10.4213 9.87083 10.663 9.6125C10.9046 9.35417 11.0255 9.05 11.0255 8.7V5H9.07545L8.52545 8.5C8.45879 8.9 8.54629 9.25 8.78795 9.55C9.02962 9.85 9.34212 10 9.72545 10ZM5.27545 10C5.57545 10 5.83795 9.89167 6.06295 9.675C6.28795 9.45833 6.42545 9.18333 6.47545 8.85L7.02545 5H5.07545L4.07545 8.35C3.97545 8.68333 4.02962 9.04167 4.23795 9.425C4.44629 9.80833 4.79212 10 5.27545 10ZM18.7755 10C19.2588 10 19.6088 9.80833 19.8255 9.425C20.0421 9.04167 20.0921 8.68333 19.9755 8.35L18.9255 5H17.0255L17.5755 8.85C17.6255 9.18333 17.763 9.45833 17.988 9.675C18.213 9.89167 18.4755 10 18.7755 10ZM5.02545 19H19.0255V11.95C18.9421 11.9833 18.888 12 18.863 12H18.7755C18.3255 12 17.9296 11.925 17.588 11.775C17.2463 11.625 16.9088 11.3833 16.5755 11.05C16.2755 11.35 15.9338 11.5833 15.5505 11.75C15.1671 11.9167 14.7588 12 14.3255 12C13.8755 12 13.4546 11.9167 13.063 11.75C12.6713 11.5833 12.3255 11.35 12.0255 11.05C11.7421 11.35 11.413 11.5833 11.038 11.75C10.663 11.9167 10.2588 12 9.82545 12C9.34212 12 8.90462 11.9167 8.51295 11.75C8.12129 11.5833 7.77545 11.35 7.47545 11.05C7.12545 11.4 6.77962 11.6458 6.43795 11.7875C6.09629 11.9292 5.70879 12 5.27545 12H5.16295C5.12129 12 5.07545 11.9833 5.02545 11.95V19Z"
                                    fill="#ACAEC4"
                                />
                            </svg>
                        </span>
                        <span className={styles['render-value-text']}>
                            {items.map((item) => item[labelKey]).join(', ')}
                        </span>
                        <span className={styles['render-value-count']}>{items.length}</span>
                    </span>
                )}
                renderMenuItem={(label, item) => (
                    <div className={styles['item']} {...item}>
                        {label}
                    </div>
                )}
                placement="bottom"
                onSelect={handleSetter}
                onClean={handleClean}
                locale={{ searchPlaceholder }}
            />
            <div ref={selectRef} style={{ zIndex: 1000, position: 'relative' }} className={styles['dropdown']}></div>
        </>
    );
};

export default ExMultiSelectionWithApply;
